import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { CompanyService } from './core/services/company.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
	constructor(private authService: AuthenticationService, private companyService: CompanyService) {}

	ngOnInit(): void {
		// Covers a hard refresh with a stored token (no token_received event fires).
		// Idempotent, so a double-load on login is harmless.
		if (this.authService.isAuthenticated()) {
			this.companyService.load();
		}
	}
}
